const form1 = document.getElementById("newsletter-form");
const form2 = document.getElementById("footer-newsletter");
const formRetailers = document.getElementById("retailers-form");

const successMessageNewsletter = document.getElementById(
  "successMessageNewsletter"
);
const errorMessageNewsletter = document.getElementById(
  "errorMessageNewsletter"
);
const successMessageFooter = document.getElementById("successMessageFooter");
const errorMessageFooter = document.getElementById("errorMessageFooter");
const successMessageRetailers = document.getElementById(
  "successMessageRetailers"
);
const errorMessageRetailers = document.getElementById("errorMessageRetailers");

if (form1) {
  // Hide success and error messages initially
  if (successMessageNewsletter) {
    successMessageNewsletter.style.display = "none";
  }
  if (errorMessageNewsletter) {
    errorMessageNewsletter.style.display = "none";
  }

  form1.addEventListener("submit", function (event) {
    event.preventDefault();
    const email = document.getElementById("Email-5").value;
    const firstName = document.getElementById("Name-3").value;
    const dogsName = document.getElementById("newsletterDogsName1").value;
    const dogsBirthday = document.getElementById(
      "newsletterDogsBirthday1"
    ).value;
    const dogsName2 = document.getElementById("newsletterDogsName2").value;
    const dogsBirthday2 = document.getElementById(
      "newsletterDogsBirthday2"
    ).value;
    const dogsName3 = document.getElementById("newsletterDogsName3").value;
    const dogsBirthday3 = document.getElementById(
      "newsletterDogsBirthday3"
    ).value;
    const dogsName4 = document.getElementById("newsletterDogsName4").value;
    const dogsBirthday4 = document.getElementById(
      "newsletterDogsBirthday4"
    ).value;
    const dogsName5 = document.getElementById("newsletterDogsName5").value;
    const dogsBirthday5 = document.getElementById(
      "newsletterDogsBirthday5"
    ).value;

    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2023-12-15",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: {
                    $dogs_name: dogsName,
                    $dogs_birthday: dogsBirthday,
                    $dogs_name2: dogsName2,
                    $dogs_birthday2: dogsBirthday2,
                    $dogs_name3: dogsName3,
                    $dogs_birthday3: dogsBirthday3,
                    $dogs_name4: dogsName4,
                    $dogs_birthday4: dogsBirthday4,
                    $dogs_name5: dogsName5,
                    $dogs_birthday5: dogsBirthday5,
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "U8piKx",
              },
            },
          },
        },
      }),
    };

    fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=XMwk6Y",
      options
    )
      .then((response) => {
        console.log(response);
        if (response.ok) {
          // Show success message
          if (successMessageNewsletter) {
            successMessageNewsletter.style.display = "block";
          }
        } else {
          // Show error message
          if (errorMessageNewsletter) {
            errorMessageNewsletter.style.display = "block";
          }
        }
      })
      .catch((err) => {
        console.error(err);
        // Show error message
        if (errorMessageNewsletter) {
          errorMessageNewsletter.style.display = "block";
        }
      });
  });
}

if (form2) {
  // Hide success and error messages initially
  if (successMessageFooter) {
    successMessageFooter.style.display = "none";
  }
  if (errorMessageFooter) {
    errorMessageFooter.style.display = "none";
  }

  form2.addEventListener("submit", function (event) {
    event.preventDefault();
    const email = document.getElementById("Email-4").value;
    const firstName = document.getElementById("Name-2").value;
    const dogsName = document.getElementById("DogsName1").value;
    const dogsBirthday = document.getElementById("DogsBirthday1").value;
    const dogsName2 = document.getElementById("DogsName2").value;
    const dogsBirthday2 = document.getElementById("DogsBirthday2").value;
    const dogsName3 = document.getElementById("DogsName3").value;
    const dogsBirthday3 = document.getElementById("DogsBirthday3").value;
    const dogsName4 = document.getElementById("DogsName4").value;
    const dogsBirthday4 = document.getElementById("DogsBirthday4").value;
    const dogsName5 = document.getElementById("DogsName5").value;
    const dogsBirthday5 = document.getElementById("DogsBirthday5").value;

    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2023-12-15",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: {
                    $dogs_name: dogsName,
                    $dogs_birthday: dogsBirthday,
                    $dogs_name2: dogsName2,
                    $dogs_birthday2: dogsBirthday2,
                    $dogs_name3: dogsName3,
                    $dogs_birthday3: dogsBirthday3,
                    $dogs_name4: dogsName4,
                    $dogs_birthday4: dogsBirthday4,
                    $dogs_name5: dogsName5,
                    $dogs_birthday5: dogsBirthday5,
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "U8piKx",
              },
            },
          },
        },
      }),
    };

    fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=XMwk6Y",
      options
    )
      .then((response) => {
        console.log(response);
        if (response.ok) {
          // Show success message
          if (successMessageFooter) {
            successMessageFooter.style.display = "block";
          }
        } else {
          // Show error message
          if (errorMessageFooter) {
            errorMessageFooter.style.display = "block";
          }
        }
      })
      .catch((err) => {
        console.error(err);
        // Show error message
        if (errorMessageFooter) {
          errorMessageFooter.style.display = "block";
        }
      });
  });
}

if (formRetailers) {
  // Hide success and error messages initially
  if (successMessageRetailers) {
    successMessageRetailers.style.display = "none";
  }
  if (errorMessageRetailers) {
    errorMessageRetailers.style.display = "none";
  }

  document.addEventListener("DOMContentLoaded", function() {
      document.getElementById('startTime').value = new Date().getTime();
    });

  formRetailers.addEventListener("submit", function (event) {
    event.preventDefault();

    var p = document.getElementById("Retailers-Address-2").value;
    var startTime = document.getElementById('startTime').value;
    var currentTime = new Date().getTime();
    var timeTaken = (currentTime - startTime) / 1000;
    
    if (p !== "" || timeTaken < 5) {
        event.preventDefault();
        return false;
      }

    /*verify reCaptcha v 3*/
    grecaptcha.ready(function () {
      grecaptcha.execute('6LcL8fApAAAAAB8ZSRhZeMzD0pf9-yRiZLnwjjmB', { action: 'submit_form' }).then(function (token) {

        const recaptchaResponse = document.createElement('input');
        recaptchaResponse.setAttribute('type', 'hidden');
        recaptchaResponse.setAttribute('name', 'recaptcha_response');
        recaptchaResponse.setAttribute('value', token);
        formRetailers.appendChild(recaptchaResponse);

        fetch('https://script.google.com/macros/s/AKfycbyxuckkqYf82XYd6bJL06HUanrdVHg2c8FDKjQM6vATOnJjPRdeWtjS1ccRwAkC9Tv-Uw/exec', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams({
            'recaptcha_response': token
          })
        })
        .then(response => response.text())
        .then(data => {
          if (data === 'reCAPTCHA verified successfully.') {
            submitFormToKlaviyo();
          } else {
            console.log('reCAPTCHA verification failed. Please try again.');
          }
        })
        .catch(error => {
          console.error('Error:', error);
          console.log('An error occurred. Please try again.');
        });
      });
    });

    function submitFormToKlaviyo() {
      const company = document.getElementById("Retailers-Company").value;
      const website = document.getElementById("Retailers-Website").value;
      const contactPerson = document.getElementById("Retailers-Person").value;
      const jobTitle = document.getElementById("Retailers-Job-Title").value;
      const country = document.getElementById("Retailers-Country").value;
      const zipCode = document.getElementById("Retailers-ZIP-Postal-Code").value;
      const address = document.getElementById("Retailers-Address").value;
      const email = document.getElementById("Retailers-Email").value;
      const phone = document.getElementById("Retailers-Phone").value;

      const relationships = {
        list: {
          data: {
            type: "list",
            id: "Sax3iQ",
          },
        },
      };

      let attr = {
        first_name: contactPerson,
        email: email,
        title: jobTitle,
        organization: company,
        location: {
          address1: address,
          country: country,
          zip: zipCode,
        },
        properties: {
          website: website,
        },
      };

      if (phone) {
        let phoneNum = phone;

        if (phoneNum.startsWith('0')) {
          phoneNum = phoneNum.substring(1);
        }

        attr = {
          ...attr,
          phone_number: `+${phoneNum}`
        };
      }

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2023-12-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: attr,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "Sax3iQ",
                },
              },
            },
          },
        }),
      };

      fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=XMwk6Y",
        options
      )
        .then((response) => {
          //console.log(response);
          if (response.ok) {
            // Show success message
            if (successMessageRetailers) {
              successMessageRetailers.style.display = "block";
            }
          } else {
            // Show error message
            if (errorMessageRetailers) {
              errorMessageRetailers.style.display = "block";
            }
          }
        })
        .catch((err) => {
          console.error(err);
          // Show error message
          if (errorMessageRetailers) {
            errorMessageRetailers.style.display = "block";
          }
        });
    }
  });

  
}
